'use strict';

import 'lazysizes';
import '../css/app.scss';
import SmoothScroll from 'smooth-scroll';

(function (window, document, $) {
	// menu開閉
	window.addEventListener('DOMContentLoaded', (event) => {
		$('.menu_btn').on('click', function () {
			$('body').toggleClass('js-menu_open');
		});
		$('a[href^="#"]').on('click', function () {
			$('body').removeClass('js-menu_open');
		});
	});

	// sticky化 sec-mvの下部が画面内にならsticky
	if (window.matchMedia('(max-width: 768px)').matches) {
		//画面横幅が768px以下のときの処理

		const fixedCvBtn = document.querySelectorAll('#js-sticky_area');
		const fixedCvBtnOptions = {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: 0,
		};
		const fixedCvBtnObserver = new IntersectionObserver(
			fixedCvBtnIntersectFunction,
			fixedCvBtnOptions
		);
		fixedCvBtn.forEach((item) => {
			fixedCvBtnObserver.observe(item);
		});
		function fixedCvBtnIntersectFunction(elements) {
			elements.forEach((element) => {
				if (element.isIntersecting) {
					$('body').addClass('js-sticky');
				} else {
					$('body').removeClass('js-sticky');
				}
			});
		}
	}

	// smoothscroll
	var scroll = new SmoothScroll('a[href*="#"]', {
		speed: 400, //スクロールする速さ
		easing: 'easeInOutCubic',
		header: '#header', //固定ヘッダーがある場合
	});
})(window, document, jQuery);
